import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/pages/admin/system-monitor/overview-page';

export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/overview'
)({
  component: OverviewPage,
});
